import { render, staticRenderFns } from "./WarningsListItem.vue?vue&type=template&id=33a06362&scoped=true&"
import script from "./WarningsListItem.vue?vue&type=script&lang=js&"
export * from "./WarningsListItem.vue?vue&type=script&lang=js&"
import style0 from "./WarningsListItem.vue?vue&type=style&index=0&id=33a06362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a06362",
  null
  
)

export default component.exports